import React, { useState, useRef, useEffect } from "react";
import { MessageCircle, X, Send, Loader2 } from "lucide-react";
import api from "../lib/api";

const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [model, setModel] = useState("claude");
  const [sessionId, setSessionId] = useState(null);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Hi! I'm the Flying Fleet Dispatch assistant. Ask me about loads, dispatch, FMCSA filing, or our services." },
  ]);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const send = async (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    setMessages((m) => [...m, { role: "user", content: text }]);
    setBusy(true);
    try {
      const r = await api.post("/chat", { session_id: sessionId, message: text, model });
      setSessionId(r.data.session_id);
      setMessages((m) => [...m, { role: "assistant", content: r.data.reply }]);
    } catch (err) {
      setMessages((m) => [...m, { role: "assistant", content: "Sorry, I ran into an error. Please call dispatch at 815-406-9774." }]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button className="chat-fab" onClick={() => setOpen((v) => !v)} aria-label="Open support chat">
        {open ? <X size={22} /> : <MessageCircle size={24} />}
      </button>

      {open && (
        <div className="chat-panel">
          <div className="chat-head">
            <div>
              <div className="chat-title">Dispatch Assistant</div>
              <div className="chat-status">Online · AI powered</div>
            </div>
            <div className="chat-model">
              <button className={model === "claude" ? "on" : ""} onClick={() => setModel("claude")}>Claude</button>
              <button className={model === "gemini" ? "on" : ""} onClick={() => setModel("gemini")}>Gemini</button>
            </div>
          </div>
          <div className="chat-body">
            {messages.map((m, i) => (
              <div key={i} className={`chat-msg ${m.role}`}>
                <div className="bubble">{m.content}</div>
              </div>
            ))}
            {busy && (
              <div className="chat-msg assistant">
                <div className="bubble typing"><Loader2 size={15} className="spin" /> Thinking...</div>
              </div>
            )}
            <div ref={endRef} />
          </div>
          <form className="chat-input" onSubmit={send}>
            <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Type your message..." />
            <button type="submit" disabled={busy} aria-label="Send"><Send size={18} /></button>
          </form>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
